import React from 'react';
import { Box } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid';
import { AdminBrokerGroupPicker } from '@/admin/shared/pickers/AdminBrokerGroupPicker';
import {
	useGetBrokerGroupQuery,
	useListAllBrokerGroupsQuery,
} from '@/admin/brokerGroups/api/brokerGroupsApi';

/**
 * Edits a row's other broker groups (AdminBrokerGroupPicker), offering only those on the
 * primary's ledger. Ones already chosen on another ledger, or that aren't broker groups,
 * still show so they can be removed, one by one or all with the clear (×) button. Saves when
 * the cell is left.
 */
export const OtherBrokerGroupsEditCell = ({ id, field, value, row }) => {
	const apiRef = useGridApiContext();
	const { data: brokerGroups = [] } = useListAllBrokerGroupsQuery();
	// currentData, not data, so the previous primary's ledger isn't used while this one loads
	const { currentData: primary } = useGetBrokerGroupQuery(row.brokerGroupId, {
		skip: !row.brokerGroupId,
	});
	const chosenIds = value ?? [];
	const excludeIds = brokerGroups
		.filter(
			(brokerGroup) =>
				brokerGroup.id === primary?.id ||
				(brokerGroup.ledger !== primary?.ledger && !chosenIds.includes(brokerGroup.id)),
		)
		.map((brokerGroup) => brokerGroup.id);

	return (
		<Box sx={{ width: '100%', px: 0.5 }}>
			<AdminBrokerGroupPicker
				value={chosenIds}
				onChange={(ids) => apiRef.current.setEditCellValue({ id, field, value: ids })}
				excludeIds={excludeIds}
			/>
		</Box>
	);
};
